module.exports = __webpack_public_path__ + "static/media/ic-medical.6d5dd011.svg";